import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import LeadingZeroesTable from "./LeadingZeroesTable";
import LeadingZeroesDeleteModal from "./LeadingZeroesDeleteModal";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const LeadingZeroesPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.LeadingZeroesView, permissionSet ?? []) ? (
        <div className={`layout__contentPage__${theme}`}>
          <LeadingZeroesTable />
          <LeadingZeroesDeleteModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default LeadingZeroesPage;
